import { c as _c } from "react/compiler-runtime";
import { markWaveReadFromCache, useClearWaveReadStateOnAddressChange, useClearWaveReadStateOnLastUnmount, useSyncWaveReadVerifiedIdentityCaches, useWaveReadCacheRefs } from "@/hooks/useMarkWaveNotificationsRead.cache";
import { useWaveReadIdentityState } from "@/hooks/useMarkWaveNotificationsRead.identity";
import type { MarkWaveNotificationsReadOptions, MarkWaveNotificationsReadResult, WaveNotificationsReadMarkerConfig, WaveNotificationsReadMarkerState, WaveReadAddressEpoch } from "@/hooks/useMarkWaveNotificationsRead.types";
import { useCallback, useMemo } from "react";
export type { MarkWaveNotificationsReadOptions, MarkWaveNotificationsReadResult, WaveNotificationsReadMarkerState } from "@/hooks/useMarkWaveNotificationsRead.types";
export const useWaveNotificationsReadMarkerState = t0 => {
  const $ = _c(27);
  const {
    address,
    activeProfileProxyId,
    activeProfileProxyCreatorId,
    walletAuth,
    invalidateNotifications
  } = t0;
  let t1;
  if ($[0] !== activeProfileProxyCreatorId || $[1] !== activeProfileProxyId || $[2] !== address || $[3] !== walletAuth) {
    t1 = {
      address,
      activeProfileProxyId,
      activeProfileProxyCreatorId,
      walletAuth
    };
    $[0] = activeProfileProxyCreatorId;
    $[1] = activeProfileProxyId;
    $[2] = address;
    $[3] = walletAuth;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const identityState = useWaveReadIdentityState(t1);
  const {
    addressKey,
    activeProfileProxyId: currentProfileProxyId,
    identityKey,
    proxyRoleIdentityKey,
    temporaryProxyRoleIdentity,
    verifiedIdentity
  } = identityState;
  let t2;
  if ($[5] !== addressKey) {
    t2 = {
      addressKey
    };
    $[5] = addressKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const addressEpoch = t2;
  let t3;
  if ($[7] !== addressEpoch || $[8] !== identityKey || $[9] !== invalidateNotifications || $[10] !== temporaryProxyRoleIdentity || $[11] !== verifiedIdentity) {
    t3 = {
      addressEpoch,
      identityKey,
      temporaryProxyRoleIdentity,
      verifiedIdentity,
      invalidateNotifications
    };
    $[7] = addressEpoch;
    $[8] = identityKey;
    $[9] = invalidateNotifications;
    $[10] = temporaryProxyRoleIdentity;
    $[11] = verifiedIdentity;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const cacheRefs = useWaveReadCacheRefs(t3);
  let t4;
  if ($[13] !== cacheRefs || $[14] !== verifiedIdentity || $[15] !== walletAuth) {
    t4 = {
      walletAuth,
      verifiedIdentity,
      cacheRefs
    };
    $[13] = cacheRefs;
    $[14] = verifiedIdentity;
    $[15] = walletAuth;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  useSyncWaveReadVerifiedIdentityCaches(t4);
  useClearWaveReadStateOnAddressChange(addressKey);
  useClearWaveReadStateOnLastUnmount(addressKey);
  let t5;
  if ($[17] !== addressEpoch || $[18] !== addressKey || $[19] !== cacheRefs || $[20] !== currentProfileProxyId || $[21] !== identityKey) {
    t5 = (waveId, options) => markWaveReadFromCache({
      waveId,
      addressKey,
      activeProfileProxyId: currentProfileProxyId,
      identityKey,
      addressEpoch,
      cacheRefs,
      options
    });
    $[17] = addressEpoch;
    $[18] = addressKey;
    $[19] = cacheRefs;
    $[20] = currentProfileProxyId;
    $[21] = identityKey;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const markWaveNotificationsRead = t5;
  let t6;
  if ($[23] !== identityKey || $[24] !== markWaveNotificationsRead || $[25] !== proxyRoleIdentityKey) {
    t6 = {
      markWaveNotificationsRead,
      identityKey,
      proxyRoleIdentityKey
    };
    $[23] = identityKey;
    $[24] = markWaveNotificationsRead;
    $[25] = proxyRoleIdentityKey;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};